<!-- KPI Row -->
<div class="row g-3 mb-4">
  <div class="col-lg col-md-6">
    <app-metric-card
      [title]="'Analyzed Documents'"
      [currentValue]="analyzedDocCount()"
      [hidePrevious]="true"
      [hideComparison]="true"
      [showLeftBorder]="true"
      leftBorderColor="var(--bs-primary)"
    ></app-metric-card>
  </div>
  <div class="col-lg col-md-6">
    <app-metric-card
      [title]="'Total Findings'"
      [currentValue]="aggregateReport().report_card.total_findings"
      [hidePrevious]="true"
      [hideComparison]="true"
      [showLeftBorder]="true"
      leftBorderColor="#49419a"
    ></app-metric-card>
  </div>
  <div class="col-lg col-md-6">
    <app-metric-card
      [title]="'Validated'"
      [currentValue]="aggregateReport().report_card.validated_count"
      [hidePrevious]="true"
      [hideComparison]="true"
      [showLeftBorder]="true"
      leftBorderColor="#28a745"
    ></app-metric-card>
  </div>
  <div class="col-lg col-md-6">
    <app-metric-card
      [title]="'Gaps Identified'"
      [currentValue]="aggregateReport().report_card.documented_not_validated_count + aggregateReport().report_card.recommended_not_documented_count"
      [hidePrevious]="true"
      [hideComparison]="true"
      [showLeftBorder]="true"
      leftBorderColor="#dc3545"
    ></app-metric-card>
  </div>
  <div class="col-lg col-md-6">
    <app-metric-card
      [title]="'Gaps Acknowledged'"
      [currentValue]="acknowledgedCount()"
      [hidePrevious]="true"
      [hideComparison]="true"
      [showLeftBorder]="true"
      leftBorderColor="var(--bs-info)"
    ></app-metric-card>
  </div>
</div>

<div class="row g-4">
  <!-- Left: Stacked Bar Chart -->
  <div class="col-lg-8">
    <div class="card">
      <div class="card-body">
        <h6 class="card-title mb-3">Coverage by Control Domain</h6>
        <div echarts [options]="domainChartOptions()" [initOpts]="{ renderer: 'canvas' }" style="height: 400px; width: 100%"></div>
      </div>
    </div>

    <!-- Domain Breakdown Table -->
    <div class="card mt-3">
      <div class="card-body">
        <h6 class="card-title mb-3">Domain Breakdown</h6>
        <div class="table-responsive">
          <table class="table table-hover table-sm mb-0">
            <thead>
              <tr>
                <th>Domain</th>
                <th class="text-center">Validated</th>
                <th class="text-center">Not Validated</th>
                <th class="text-center">Recommended</th>
                <th class="text-center">Unverifiable</th>
                <th class="text-center">Total</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (domain of aggregateReport().domain_breakdown; track domain.domain) {
                <tr>
                  <td class="fw-medium">{{ domain.display_name }}</td>
                  <td class="text-center">
                    <span class="badge bg-success">{{ domain.validated }}</span>
                  </td>
                  <td class="text-center">
                    <span class="badge bg-danger">{{ domain.documented_not_validated }}</span>
                  </td>
                  <td class="text-center">
                    <span class="badge bg-warning text-dark">{{ domain.recommended_not_documented }}</span>
                  </td>
                  <td class="text-center">
                    <span class="badge bg-secondary">{{ domain.not_verifiable + domain.potentially_verifiable }}</span>
                  </td>
                  <td class="text-center fw-bold">{{ domain.total }}</td>
                  <td class="text-end">
                    <button class="btn btn-sm btn-outline-primary" (click)="onDomainClick(domain.domain)">
                      Drill In
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Right: Report Card -->
  <div class="col-lg-4">
    <app-report-card-summary [reportCard]="aggregateReport().report_card"></app-report-card-summary>

    <div class="card mt-3">
      <div class="card-body">
        <h6 class="card-title mb-2">Analysis Summary</h6>
        <p class="text-muted small mb-2">
          This aggregate view combines findings from {{ analyzedDocCount() }} analyzed documents
          across {{ aggregateReport().domain_breakdown.length }} control domains.
        </p>
        <p class="text-muted small mb-0">
          Last analysis: {{ formatDate(aggregateReport().last_analysis_date) }}
        </p>
      </div>
    </div>
  </div>
</div>
